import { useCallback, useRef, useState } from 'react'

export const useInsertNoteFormComponent = () => {
    const [isEdit, setIsEdit] = useState(false)

    const toggleIsEdit = useCallback(() => setIsEdit((isEdit) => !isEdit), [])

    const confirmedNoteRef = useRef<string>(null)

    const isConfirmed = !!confirmedNoteRef?.current

    const handleConfirm = useCallback(
        (note: string) => {
            confirmedNoteRef.current = note

            toggleIsEdit()
        },
        [toggleIsEdit]
    )

    const handleCancel = useCallback(() => {
        if (!isConfirmed) confirmedNoteRef.current = null

        toggleIsEdit()
    }, [isConfirmed, toggleIsEdit])

    const handleDelete = useCallback(() => {
        confirmedNoteRef.current = null

        toggleIsEdit()
    }, [toggleIsEdit])

    return [
        confirmedNoteRef,
        { isEdit, toggle: toggleIsEdit },
        { onConfirm: handleConfirm, onCancel: handleCancel, onDelete: handleDelete },
    ] as const
}
